import React from "react";
import "../styles/VideoSection.css"; 

const VideoSection = () => {
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  return (
    <>
    <section className="video-section">
        <h2><span className="highlight">Reddy Anna:</span> Happy Clients Always <span className="highlight">Love Us</span></h2>
        {/* Description Section */}
        <div className="video-description">
          <p>
          At Reddy Anna Book, we take pride in delivering excellence that resonates with our clients. Our dedication to offering premium services and a seamless user experience is evident in the glowing feedback we receive from satisfied users. Their testimonials reflect our unwavering commitment to creating a platform that goes beyond expectations. Join the Reddy Book community and discover the thrill of online gaming with a platform that’s cherished by its users for delivering an unmatched experience.
          </p>
        </div>

        {/* Video Preview Section */}
        <div
          className="video-preview"
          style={{
            backgroundImage: "url('vdo.webp')", 
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "100px", 
            width: "65%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="play-button">
            <i className="play-icon">▶</i>
          </div>
        </div>

        {/* Statistics Section */}
        <div className="statistics">
          {/* Happy Clients */}
          <div className="stat-item">
            <h3>42,000+</h3>
            <p>Happy Clients</p>
          </div>
          {/* Application Users */}
          <div className="stat-item">
            <h3>2.5 Lakh+</h3>
            <p>Application users</p>
          </div>
          {/* Rating */}
          <div className="stat-item">
            <h3>4.8</h3>
            <p>Rating</p>
          </div>
        </div>
        <div className="vdo-btn">
      <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Open Your Demo Account
          </a>
          <a
            href={ContactLink}
            target="_blank"
            rel="noopener noreferrer"
            className="contactus-button"
          >
            Contact Us Now
          </a>
    </div>
    </section>
    </>
  );
};

export default VideoSection;
